import './Diensten.css';

const DvDiensten_default = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-home"></i>
                        </div>
                        <h4>Vastverblijf</h4>
                        <p>Zorgnetwerk Trento kan nooit 'uw thuis' vervangen. Toch streven we er naar waar mogelijk uw leefgewoonten in te passen.</p>
                        <a href="https://www.zorgnetwerktrento.be" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DvDiensten_default;

const DvDiensten_Vast = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-home"></i>
                        </div>
                        <h4>Vastverblijf</h4>
                        <p>Zorgnetwerk Trento kan nooit 'uw thuis' vervangen. Toch streven we er naar waar mogelijk uw leefgewoonten in te passen.</p>
                        <a href="https://www.zorgnetwerktrento.be/verblijven-in-ons-woonzorgcentrum-de-vliet" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const DvDiensten_Kort = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-door-open"></i>
                        </div>
                        <h4>Kortverblijf</h4>
                        <p>
                            Wij bieden ook kortverblijf aan. Dit tijdelijk verblijf kan variëren van een aantal dagen tot een aantal weken, in samenspraak met u en uw familie. De wettelijk voorziene duur is maximaal 60 opeenvolgende dagen en maximaal 90 dagen per kalenderjaar in hetzelfde centrum.
                        </p>
                        <a href="https://www.zorgnetwerktrento.be/kortverblijf-wzc-de-vliet" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const DvDiensten_Somp = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-hand-holding-heart"></i>
                        </div>
                        <h4>SOM +</h4>
                        <p>SOM+ is een RIZIV-project dat loopt t.e.m. december 2022 waarbij woonzorgcentra en thuiszorgdiensten uit de buurt nauw samenwerken. Zij gaan samen met u en uw omgeving op weg.</p>
                        <a href="https://www.zorgnetwerktrento.be/som-wzc-de-vliet" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const DvDiensten_Orie = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-suitcase"></i>
                        </div>
                        <h4>Oriënterend kortverblijf</h4>
                        <p>Info over Oriënterend kortverblijf.</p>
                        <a href="https://www.zorgnetwerktrento.be/orienterend-kortverblijf-wzc-de-vliet" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

const DvDiensten_coma = () => {
    return (
        <section class="our-skills">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6 col-md-4"></div>
                    <div className="box-shadow">
                        <div className="icon">
                            <i className="fas fa-procedures"></i>
                        </div>
                        <h4>Zorg voor personen in coma</h4>
                        <p>In campus De Vliet bieden wij zorgverblijf voor personen in coma aan.</p>
                        <a href="https://www.zorgnetwerktrento.be/zorg-voor-personen-coma" target="_top" className="ref">
                            Lees Meer <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export { DvDiensten_Kort, DvDiensten_Orie, DvDiensten_Vast, DvDiensten_Somp, DvDiensten_coma };
